// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2JMe-","footer":"ChangeClinic_footer__31SYS"};